import React from 'react';
import { COLORS } from '../../styles/tokens';

// Tre steg: Henting, Transport, Levering. Utledes av ordrestatus.
export function stepState(status) {
  return {
    isPickup:   status === 'matched',
    isDelivery: status === 'in_progress',
    isPending:  status === 'delivered_pending',
    isDone:     status === 'completed',
  };
}

function Dot({ n, done, active, label }) {
  const bg = done ? COLORS.primary : active ? COLORS.accent : COLORS.white;
  const border = done || active ? COLORS.primary : COLORS.border;
  const color = done ? '#fff' : COLORS.primary;
  return (
    <div role="listitem" aria-current={active ? 'step' : undefined} style={{ textAlign: 'center', minWidth: 64 }}>
      <div style={{
        width: 30, height: 30, borderRadius: '50%', background: bg, color,
        border: `2px solid ${border}`, boxSizing: 'border-box',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontSize: 13, fontWeight: 700, margin: '0 auto 4px',
      }}>
        {done ? '✓' : n}
      </div>
      <span style={{ fontSize: 12, color: done || active ? COLORS.textDark : COLORS.textLight, fontWeight: active ? 700 : 500 }}>{label}</span>
    </div>
  );
}

export default function OrderSteps({ status }) {
  const { isPickup, isDelivery, isPending, isDone } = stepState(status);
  const line = on => ({ flex: 1, height: 2, margin: '14px 4px 0', background: on ? COLORS.primary : COLORS.border });
  return (
    <div style={{ display: 'flex', alignItems: 'flex-start', padding: '0 4px' }} role="list" aria-label="Fremdrift">
      <Dot n={1} done={!isPickup} active={isPickup} label="Henting" />
      <div style={line(!isPickup)} />
      <Dot n={2} done={isPending || isDone} active={isDelivery} label="Transport" />
      <div style={line(isPending || isDone)} />
      <Dot n={3} done={isDone} active={isPending} label="Levering" />
    </div>
  );
}
